import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFilterData } from '../../features/mainFilter/selectors';
import { selectSecondaryFilter } from '../../features/secondaryFilter/secondaryFilterSlice';
import { prepareSearchRequest, saveDealsFromPreFetch } from '../../features/dealsList/dealsListSlice';
import { prefetchDeals } from '../../features/dealsList/prefetchDealsSlice';
import { abortControllerManager } from '../../services/AbortControllerManager';
import { pushEvent } from '../../utilities/analytics';
import { LOAD_SEARCH_RESULTS_TO_DISPLAY_EVENT } from '../../constants/analyticEvents';

const useWarmupDeals = (isEnabled) => {
  const dispatch = useDispatch();
  const mainFilter = useSelector(selectFilterData);
  const secondaryFilter = useSelector(selectSecondaryFilter);
  const { deals, saveDirectly, pagination } = useSelector(state => state.prefetchDeals);
  const warmupEnabled = !window.holidayFinder.abTest?.resultsPrefetchEnabled || isEnabled;

  const warmupDealsCache = useCallback(async (props) => {
    if (!warmupEnabled) {
      return;
    }

    abortControllerManager.abortRequest('warmup-deals')

    let mainFilterUpdated = {
      ...mainFilter.searchEngine,
    };

    let secondaryFilterUpdated = {
      ...secondaryFilter.data,
    }

    if (props.fromwhere) {
      mainFilterUpdated.fromwhere = props.fromwhere;
    }

    if (props.what) {
      mainFilterUpdated.what = props.what;
    }

    if (props.where) {
      mainFilterUpdated.where = props.where;
    }

    if (props.who) {
      mainFilterUpdated.who = props.who;
    }

    if (props.when) {
      mainFilterUpdated.when = {
        ...mainFilterUpdated.when,
        ...props.when,
      };
    }

    if (props.budget) {
      mainFilterUpdated.budget = {
        ...mainFilterUpdated.budget,
        min: props.budget[0],
        max: props.budget[1],
      };
    }

    if (props.stars) {
      secondaryFilterUpdated.stars = props.stars;
    }

    if (props.board) {
      secondaryFilterUpdated.board = props.board;
    }

    if (props.facilities) {
      secondaryFilterUpdated.facilities = props.facilities;
    }

    if (props.sort) {
      secondaryFilterUpdated.sort = props.sort;
    }

    if (props.stops) {
      secondaryFilterUpdated.stops = props.stops;
    }

    if (props.freeCancellation) {
      secondaryFilterUpdated.freeCancellation = props.freeCancellation;
    }

    if (props.flex) {
      secondaryFilterUpdated.flex = props.flex;
    }

    if (props.luggage) {
      secondaryFilterUpdated.luggage = props.luggage;
    }

    const request = prepareSearchRequest({
      mainFilter: mainFilterUpdated,
      secondaryFilter: secondaryFilterUpdated,
      hotel: props.hotel
    });

    dispatch(prefetchDeals({ request, signal: abortControllerManager.getSignal('warmup-deals') }));
  }, [mainFilter, secondaryFilter, dispatch]);

  useEffect(() => {
    if (saveDirectly && deals.length > 0) {
      dispatch(saveDealsFromPreFetch({
        deals,
        pagination,
      }));
      pushEvent(LOAD_SEARCH_RESULTS_TO_DISPLAY_EVENT, {
        loadDurationTime: 0.1,
        responseData: {
          data: {
            deals,
            pagination,
          }
        },
        requestType: "fetchDealsList"
      });
    }
  }, [dispatch, deals, saveDirectly, pagination])

  return {
    warmupDealsCache
  };
}

export default useWarmupDeals;
